import i from './images/ds.jpg';
import i1 from './images/bca.jpg';
import Header from './Header';


const courses=[
{
        id: 1,
        title: "Data Structure",
        author: "Prof Manjunath",
        category:"Engineering",
        type: "FREE",
        image: i,
    },
    {
        id: 2,
        title: "Business Management",
        author: "Prof Latha",
        category:"BCA",
        type: "FREE",
        image: i1,
    },
    {
        id:3,
        title: "Data Structure",
        author: "Prof Manjunath",
        category:"Engineering",
        type: "FREE",
        image: i,
    },
    {
        id: 4,
        title: "Business Management",
        author: "Prof Latha",
        category:"BCA",
        type: "FREE",
        image: i1,
    },
    
]

export default courses;


